const API_BASE = (process.env.REACT_APP_API_URL || '') + '/api/auth';

async function authFetch(endpoint, options = {}) {
  const { headers, ...rest } = options;
  const res = await fetch(`${API_BASE}${endpoint}`, {
    ...rest,
    headers: { 'Content-Type': 'application/json', ...headers },
  });
  const data = await res.json();
  if (!res.ok) {
    const err = new Error(data.error || 'Er is een fout opgetreden');
    // Sessiecode van de server (session_expired / invalid_token / token_required),
    // zodat AuthContext een verlopen sessie kan benoemen op het loginscherm.
    if (data.code) err.code = data.code;
    throw err;
  }
  return data;
}

// Lopende sessie verlengen: nieuw token met dezelfde identiteit (schuivende sessie).
export function refreshSession(authToken) {
  return authFetch('/refresh', {
    method: 'POST',
    headers: { Authorization: `Bearer ${authToken}` },
  });
}

export function register(authToken, spec) {
  return authFetch('/register', {
    method: 'POST',
    headers: { Authorization: `Bearer ${authToken}` },
    body: JSON.stringify(spec),
  });
}

export function deleteUser(authToken, userId) {
  return authFetch(`/users/${userId}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${authToken}` },
  });
}


// Uitnodiging opnieuw versturen. De server zet daarbij een NIEUW tijdelijk
// wachtwoord — het oude staat alleen als hash in de database.
export function resendWelcome(authToken, userId) {
  return authFetch(`/users/${userId}/resend-welcome`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${authToken}` },
  });
}

// Account (de)activeren: het alternatief voor verwijderen (historiek blijft).
export function setUserActive(authToken, userId, active) {
  return authFetch(`/users/${userId}/active`, {
    method: 'PUT',
    headers: { Authorization: `Bearer ${authToken}` },
    body: JSON.stringify({ active }),
  });
}

export function login(email, password) {
  return authFetch('/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });
}

export function requestPasswordReset(email) {
  return authFetch('/request-password-reset', {
    method: 'POST',
    body: JSON.stringify({ email }),
  });
}

export function resetPassword(token, newPassword) {
  return authFetch('/reset-password', {
    method: 'POST',
    body: JSON.stringify({ token, newPassword }),
  });
}

export function verifyMfaSetup(userId, token) {
  return authFetch('/verify-mfa-setup', {
    method: 'POST',
    body: JSON.stringify({ userId, token }),
  });
}

export function verifyMfa(userId, token) {
  return authFetch('/verify-mfa', {
    method: 'POST',
    body: JSON.stringify({ userId, token }),
  });
}

export function getMe(authToken) {
  return authFetch('/me', {
    headers: { Authorization: `Bearer ${authToken}` },
  });
}

export function getUsers(authToken) {
  return authFetch('/users', {
    headers: { Authorization: `Bearer ${authToken}` },
  });
}

export function updateUserRole(authToken, userId, spec) {
  return authFetch(`/users/${userId}/role`, {
    method: 'PUT',
    headers: { Authorization: `Bearer ${authToken}` },
    body: JSON.stringify(spec),
  });
}

// Je EIGEN persoonlijke API-sleutel (Odoo-koppeling). Apart van updateUserRole,
// want je eigen rij bewerken is daar bewust geblokkeerd. Lege string = wissen.
export function updateOwnEtApiKey(authToken, sleutel) {
  return authFetch('/me/et-api-key', {
    method: 'PUT',
    headers: { Authorization: `Bearer ${authToken}` },
    body: JSON.stringify({ et_api_key: sleutel }),
  });
}

export function impersonateUser(authToken, userId) {
  return authFetch(`/impersonate/${userId}`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${authToken}` },
  });
}

export function stopImpersonate(authToken) {
  return authFetch('/stop-impersonate', {
    method: 'POST',
    headers: { Authorization: `Bearer ${authToken}` },
  });
}

// Eenmalige code voor de sessie achter `authToken`, om die naar een ander
// merkdomein (andere origin, dus andere localStorage) mee te nemen.
export function createHandoff(authToken) {
  return authFetch('/handoff', {
    method: 'POST',
    headers: { Authorization: `Bearer ${authToken}` },
  });
}

export function exchangeHandoff(code) {
  return authFetch('/handoff/exchange', {
    method: 'POST',
    body: JSON.stringify({ code }),
  });
}

export function acceptPrivacy(authToken) {
  return authFetch('/accept-privacy', {
    method: 'POST',
    headers: { Authorization: `Bearer ${authToken}` },
  });
}

export function exportData(authToken) {
  return authFetch('/export-data', {
    headers: { Authorization: `Bearer ${authToken}` },
  });
}

export function deleteAccount(authToken, password) {
  return authFetch('/account', {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${authToken}` },
    body: JSON.stringify({ password }),
  });
}

export function changePassword(authToken, oldPassword, newPassword) {
  return authFetch('/change-password', {
    method: 'PUT',
    headers: { Authorization: `Bearer ${authToken}` },
    body: JSON.stringify({ oldPassword, newPassword }),
  });
}

export function getAuditLogs(authToken, page = 1) {
  return authFetch(`/audit-logs?page=${page}`, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
}
